import { FastagUserData, WrongModalState } from '@interfaces/fastag'

export const POPULAR_PROVIDERS = 'Popular Providers'

export const OTHER_PROVIDERS = 'Other providers'

export const SEARCH_FASTAG_PROVIDER_PLACEHOLDER = 'Search for your provider'

export const NO_RESULTS = 'No results found'

export const BLACK_BACK_ICON = 'https://acko-cms.ackoassets.com/black_back_icon_570e62096c.svg'

export const BBPS_LOGO_SRC = 'https://acko-cms.ackoassets.com/BBPS_logo_a4354602e5.svg'

export const UNABLE_PROCESSING_SRC = 'https://acko-cms.ackoassets.com/Unable_to_process_73e7c96868.svg'

export const WRONG_PROVIDER_SELECTION_DATA = {
  heading: 'You have selected the wrong FASTag provider',
  subHeading: 'This FASTag is not linked or does not exist. Please select the right FASTag.',
  ctaText: 'Try again',
}

export const UNABLE_TO_FETCH_BALANCE_DATA = {
  heading: 'There seems to be an error with the FASTag servers',
  subHeading: 'This is quite unusual. Please try again after some time.',
  ctaText: 'Okay',
}

export const requiredKeys = ['mobile_number', 'reg_number', 'vehicleInfo', 'selectedProvider']

export const checkFastagLSData = localStorageData => requiredKeys.every(key => localStorageData[key] !== undefined)

export const initUserData: FastagUserData = {
  mobile_number: '',
  reg_number: '',
  selectedProvider: null,
  fastagData: null,
  vehicleImage: '',
  vehicleInfo: null,
  logo_url: '',
}

export const defaultWrongModalState: WrongModalState = { show: false, isServerError: false }
